// @flow

import { combineReducers } from 'redux'
import {
  activeMunicipality,
  rentPricesByMunicipality
} from '../components/map/reducer'
import { requestStatus } from '../components/loadingIndicator/reducer'
import type { RequestStatus } from '../components/loadingIndicator/reducer'
import { categorySelection } from '../components/selector/reducer'
import type { CategorySelectionState } from '../components/selector/reducer'
import { popupReducer as popup } from 'components/popup/reducer'
import type { InteractionCapabilities } from '../components/interactionCapabilities/reducer'
import interactionCapabilities from 'components/interactionCapabilities/reducer'
import type { PopupState } from 'components/popup/reducer'
import type { Municipality } from 'components/../sources/types'
import type { D3Map } from 'components/choroplethMap/choroplethMapComponent'

export type AppState = {
  +rentPricesByMunicipality: D3Map<Municipality>,
  +activeMunicipality: number,
  +requestStatus: RequestStatus,
  +categorySelection: CategorySelectionState,
  +popup: PopupState,
  +interactionCapabilities: InteractionCapabilities
}

export const rentPriceMapReducers: (
  state: AppState,
  action: any
) => AppState = combineReducers({
  rentPricesByMunicipality,
  activeMunicipality,
  requestStatus,
  categorySelection,
  popup,
  interactionCapabilities
})
